module.exports = __webpack_public_path__ + "static/usvojili-smo-baku-i-djeda-80f34315d50a9a2309e01be55bbbad87.png";